<template>
    <div class="main">
        <h2>Create Together</h2>
        <share-box :centerLayout="true" :emailConfig='emailConfig'></share-box>
        <div class="section" v-for="(item, index) in list" :key="index">
            <p class="title">{{item.title}}</p>
            <p class="text" v-for="items in item.text" :key="items">{{items}}</p>
        </div>
        <div class="logo-box">
            <div class="content">
                <div>Partner</div>
                <dyna-img class="img-left" :src="logo1" />
            </div>
            <div class="content">
                <div>Supported by</div>
                <dyna-img :src="logo2" />
            </div>
        </div>
    </div>
</template>

<script>
import ShareBox from '@/components/shareBox'
import DynaImg from "@/components/dynaImg";
    export default {
        name: 'CreateTogether',
        data() {
            return {
                emailConfig: {
                    title: "「竞技场」征集主题优秀作品公布",
                },
                logo1: 'https://vivovisionplus.oss-cn-shenzhen.aliyuncs.com/static/images/bottom_nav/bottom-national-test.svg',
                logo2: 'https://vivovisionplus.oss-cn-shenzhen.aliyuncs.com/static/images/bottom_nav/bottom-zeiss-test.svg',
                list: [
                    {
                        title: 'vivo sees the creator/storyteller in you',
                        text: [
                            'Today, through smartphones, we constantly create memories of people, moments, and experiences and carry them with us. Smartphones have become a canvas for us to express ourselves and document every moment of our life in a vivid style. It is an elaborate way of social interaction, where images have turned into a global language, as important as texts.',
                            'This form of creation can happen anytime, anywhere, and can embrace every part of people\'s life. vivo, as a pioneer and innovator in mobile imaging technologies, not only acknowledges but also encourages this evolution. vivo aims to continuously inspire, and echo people\'s desire for aesthetics through excellent devices that contain ultimate mobile imaging technology. vivo understands that with development of this technology, and evolving user behaviour, the future of smartphone photography rests, not only on the manufacturers, but also on the creators. vivo wants this not to be a hurdle but an enabler.'
                        ]
                    },
                    {
                        title: 'The Idea: VISION+ 2021',
                        text: [
                            'With this fundamental idea, keeping Creator at the centre, vivo introduced VISION+ at a global level, to develop a smartphone imaging ecosystem. Through the VISION+ Project, vivo initiated an open "dialogue" in 2020 with creators from all over the world, on smartphone photography and filmmaking, attracting leading imaging technology and content developers like ZEISS, National Geographic as partners.',
                            'With the objective to "Create Together", at the core of its philosophy, VISION+ aims to encourage creative spirit and artistic expression. VISION+ brings together creators -photographers  and filmmakers around the world, from both the professional circle s and the general public. Through this, vivo will unite and inspire people, in their pursuit to reach pinnacles of creativity, storytelling and self-expression using the most advanced imaging technology in their hands in form of a smartphone. Through VISION+, vivo wants to champion the spirit of creativity and self-expression by making smartphone photography more professional, user-friendly and easy to operate.'
                        ]
                    },
                    {
                        title: 'Let’s Create Together',
                        text: [
                            'In the continuous pursuit to bring the pleasure and joyful experience of smartphone image creation to more people, the VISION+ Project will comprehensively work on initiatives to build an ecosystem that integrates photography, creation and art through collaborations.',
                            'The VISION+ Project will continue to work with creators in the future to discover more real and moving details of life. We look forward to add a beautiful touch to the humanistic environment of this era.'
                        ]
                    },
                ]
            }
        },
        components : {
            ShareBox,
            DynaImg,
        },
    }
</script>

<style lang="scss" scoped>
    .main {
        width: 800px;
        margin: 0 auto;
        padding-top: 120px;
        color: #666666;
        font-family: "font-HYQH-55S";
        font-size: 16px;
        line-height: 1.5;
        h2,.title {
            color: #242933;
            font-family: "font-HYQH-65S";
        }
        h2 {
            font-size: 46px;
            margin-bottom: 20px;
        }
        .title {
            font-size: 24px;
            margin-bottom: 24px;
        }
        .text {
            margin-bottom: 30px;
        }
        .section {
            margin-top: 50px;
            &:first-child {
                margin-top: 77px;
            }
        }
        .logo-box {
            width: 600px;
            height: auto;
            margin: 0 auto;
            margin-bottom: 180px;
            margin-top: 130px;
            display: flex;
            justify-content: space-between;
            .content {
                display: flex;
                align-items: center;
                div {
                    margin-right: 30px;
                    font-family: 'font-HYQH-55S';
                    font-size: 12px;
                    color: #8A8F99;
                    white-space: nowrap;
                }
            }
            img { 
                width: 126px;
                height: 98px;
            }
            .img-left {
                width: 126px;
                height: auto;
            }
        }
    }
    @media screen and (min-width: 1921px) {
        .main {
            width: 800Px;
            padding-top: 120Px;
            font-size: 16Px;
            h2 {
                font-size: 46Px;
                margin-bottom: 20Px;
            }
            .title {
                font-size: 24Px;
                margin-bottom: 24Px;
            }
            .text {
                margin-bottom: 30Px;
            }
            .section {
                margin-top: 50Px;
                &:first-child {
                    margin-top: 77Px;
                }
            }
            .logo-box {
                width: 600Px;
                margin-bottom: 180Px;
                margin-top: 130Px;
                .content {
                    div {
                        margin-right: 30Px;
                        font-size: 12Px;
                    }
                }
                img { 
                    width: 126Px;
                    height: 98Px;
                }
                .img-left {
                    width: 126Px;
                }
            }
        }
    }
    @media screen and (max-width: 768px) {
        .main {
            padding-top: 80*5.12px;
            font-size: 16*5.12px;
            width: 335*5.12px;
            h2,.title {
            color: #242933;
            font-family: "font-HYQH-65S";
        }
        h2 {
            font-size: 32*5.12px;
            margin-bottom: 36*5.12px;
        }
        .title {
            font-size: 20*5.12px;
            margin-bottom: 24*5.12px;
        }
        .text {
            margin-bottom: 24*5.12px;
        }
        .section {
            margin-top: 24*5.12px;
            &:first-child {
                margin-top: 60*5.12px;
            }
        }
            .logo-box {
                width: 100%;
                height: auto;
                margin-bottom: 120 * 5.12px;
                margin-top: 80 * 5.12px;
                flex-direction: column;
                align-items: center;
                .content {
                    flex-wrap: wrap;
                    width: 90 * 5.12px;
                    justify-content: center;
                    margin-bottom: 50 * 5.12px;
                    &:last-child {
                        margin-bottom: 0;
                    }
                    div {
                        margin-right: 0;
                        font-size: 12 * 5.12px;
                    }
                }
                img { 
                    width: 48 * 5.12px;
                    height: 48 * 5.12px;
                    margin-top: 20 * 5.12px;
                }
                .img-left {
                    width: 89 * 5.12px;
                    height: 70 * 5.12px;
                    margin-top: 10 * 5.12px;
                }
            }
        }
    }
</style>